import { createFileRoute } from "@tanstack/react-router";

import { AddressPage } from "../features/space/AddressPage";

/** The same address with the role pinned, so a tab acts as that person instead of asking. */
export const Route = createFileRoute("/$address_/$role")({
  component: PinnedRoleRoute,
});

function PinnedRoleRoute() {
  const { address, role } = Route.useParams();
  return <AddressPage address={address} as={role} />;
}
